import { render, staticRenderFns } from "./gmzlrBody.vue?vue&type=template&id=f2f161ac&scoped=true&"
import script from "./gmzlrBody.vue?vue&type=script&lang=js&"
export * from "./gmzlrBody.vue?vue&type=script&lang=js&"
import style0 from "./gmzlrBody.vue?vue&type=style&index=0&id=f2f161ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f161ac",
  null
  
)

export default component.exports